import { makeRequestGet, makeRequestGet2, makeRequestPost2 } from "../api";
import Cookies from "js-cookie";

function getToken() {
  return new Promise((resolve) => {
    const checkToken = () => {
      let token = Cookies.get("token");
      if (token) {
        resolve(token);
      } else {
        setTimeout(checkToken, 100); 
      }
    };
    checkToken();
  });
}

export async function getTrips() {
  let token = await getToken();
  return makeRequestGet2(`trips/`, token);
}

export async function getTripsById(id) {
  let token = await getToken();
  return makeRequestGet2(`trips/${id}`, token);
}

export async function getCo2SavingsByPeriod(data) {
  let token = await getToken();
  return makeRequestPost2(`trips/co2savings`,data, token);

}

export async function postTrips(data) {
  let token = await getToken();
  return makeRequestPost2(`trips/`, data, token);
}

